import { render, staticRenderFns } from "./loan-payment-card.vue?vue&type=template&id=57bc4a1c&scoped=true&"
import script from "./loan-payment-card.vue?vue&type=script&lang=js&"
export * from "./loan-payment-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc4a1c",
  null
  
)

export default component.exports